import { Box, Grid, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

export const CardsContainer = styled(Box)(() => ({
  display: 'flex',
  gap: 12,
  flexDirection: 'column',
}));

export const AssociatedCard = styled(Grid)(({ theme }) => ({
  padding: '21.5px 16px',
  border: `1px solid ${theme.palette.primary.main}`,
  background: alpha(theme.palette.primary.main, 0.05),
  borderRadius: 10,
}));

export const StatusGrid = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
}));

export const SmallStyledInput = styled(Typography)(() => ({
  fontWeight: '600',
  textAlign: 'justify',
}));

export const OSLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
  '&:hover': {
    color: theme.palette.secondary.main,
  },
}));

export const ItemStatus = styled(Typography)(() => ({
  padding: '6px 12px',
  fontSize: 12,
  fontWeight: 500,
  background: '#F2F2F2',
  borderRadius: 20,
}));
